<template>
  <div class="invite">
    <v-card>
      <v-card-text>
        <v-form ref="acceptForm" class="mt-10" @submit.prevent="acceptInvite">
          <v-row>
            <v-col md="6" sm="6" cols="12">
              <v-text-field
                label="First Name"
                v-model="invite.firstName"
                disabled
                name="firstname"
                class="gotham-light font-w-normal font-normal font-12"
                color="#666666"
                hide-details="auto"
                outlined
                small
              ></v-text-field>
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <v-text-field
                label="Last Name"
                v-model="invite.lastName"
                disabled
                name="lastname"
                class="gotham-light font-w-normal font-normal font-12"
                color="#666666"
                hide-details="auto"
                outlined
              ></v-text-field>
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <v-text-field
                label="Email Address"
                disabled
                v-model="invite.email"
                name="email"
                class="gotham-light font-w-normal font-normal font-12"
                color="#666666"
                hide-details="auto"
                outlined
              ></v-text-field>
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <v-text-field
                label="Password"
                v-model="invite.password"
                :rules="passwordRules"
                name="password"
                class="gotham-light font-w-normal font-normal font-12"
                color="#666666"
                type="password"
                hide-details="auto"
                outlined
              ></v-text-field>
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <v-text-field
                label="Gdc nummber"
                disabled
                outlined
                v-model="invite.gdcNumber"
              ></v-text-field>
            </v-col>
            <v-col md="6" sm="6" cols="12">
              <v-select
                :items="userPositions"
                v-model="invite.userPositionId"
                name="userposition"
                label="Position"
                disabled
                class="gotham-light font-w-normal font-normal font-12"
                color="#666666"
                outlined
                value
                item-text="name"
                item-value="id"
                hide-details="auto"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="mt-6">
            <v-col>
              <v-btn
                type="submit"
                block
                color="appGreen white--text gotham-medium font-bold font-16"
              >
                Accept
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["id"],
  data() {
    return {
      passwordRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 6) || "Password must be at least 6 characters",
        v => (v && v.length <= 15) || "Password must be at least 15 characters"
      ]
    };
  },
  computed: {
    ...mapState({
      invite: state => state.invite.invite,
      userPositions: state => state.user.userPositions
    })
  },
  async mounted() {
    await this.$store.dispatch("invite/GET_INVITE", this.id);
    await this.$store.dispatch("user/GET_USER_POSITIONS", {
      from: 0,
      to: 0
    });
  },
  methods: {
    async acceptInvite() {
      if (this.$refs.acceptForm.validate()) {
        this.$swal({
          title: "Accepting invitation",
          html: "Please hold on for a moment",
          icon: "info"
        });
        await this.$store.dispatch("invite/ACCEPT_INVITE", {
          id: this.id,
          password: this.invite.password
        });
        this.$swal({
          title: "Success",
          html: "You can now login",
          icon: "info"
        });
      }
    }
  }
};
</script>
<style lang="scss">
.invite .vue-tel-input-vuetify .v-input__slot {
  min-height: 56px !important;
}
.invite .vue-tel-input-vuetify .country-code .v-input__slot {
  min-height: 56px !important;
}
</style>
